/**
 * The theme of every application on this host, in a cookie because that ignores the port. It
 * grants nothing. public/theme.js and code.overheid.nl's header.tmpl read the same cookie.
 */
const COOKIE = /(?:^|; )portal-theme=(light|dark)/;

/** The Backstage theme to use; undefined follows the system. */
export const readThemeChoice = () => {
  const choice = COOKIE.exec(document.cookie)?.[1];
  return choice ? `rijk-${choice}` : undefined;
};
